const MAGIC_LINK_EMAIL_KEY = "cognito_magic_link_email";
const MAGIC_LINK_EMAIL_TTL_MS = 30 * 60 * 1000; // 30 minutes

interface MagicLinkEmailData {
  email: string;
  expiresAt: number;
}

/**
 * Persists the email the user requested a magic link for, so the redemption
 * page can resolve it silently on the same device. Bounded by a short TTL so
 * a stale cache can't leak past the link's own lifetime.
 *
 * Mirrors cbh-mobile-app/src/lib/cognito/src/lib/magicLinkEmailStore.ts.
 * Distinct from the longstanding `emailForSignIn` key, which has a broader
 * "remember last user" purpose and no TTL.
 */
export function setMagicLinkEmail(email: string): void {
  const data: MagicLinkEmailData = {
    email,
    expiresAt: Date.now() + MAGIC_LINK_EMAIL_TTL_MS,
  };
  localStorage.setItem(MAGIC_LINK_EMAIL_KEY, JSON.stringify(data));
}

export function getMagicLinkEmail(): string | undefined {
  const raw = localStorage.getItem(MAGIC_LINK_EMAIL_KEY);
  if (!raw) {
    return undefined;
  }

  try {
    const data = JSON.parse(raw) as MagicLinkEmailData;
    if (Date.now() > data.expiresAt) {
      localStorage.removeItem(MAGIC_LINK_EMAIL_KEY);
      return undefined;
    }
    return data.email;
  } catch {
    localStorage.removeItem(MAGIC_LINK_EMAIL_KEY);
    return undefined;
  }
}

export function clearMagicLinkEmail(): void {
  localStorage.removeItem(MAGIC_LINK_EMAIL_KEY);
}
